import { Check as MdCheck } from 'components/icons'
import { LinkExternal01 as RiShareBoxFill } from 'components/icons'
import { GButton } from '../../../../components/basic-blocks'
import { AFFILIATE_LOGIN_URL, AFFILIATE_SIGNUP_URL, EXTERNAL_APP_BASE_URL } from '../../../../utils/app-links'

export const AffiliateAbout = () => {
	return (
		<div className="w-full px-6 bg-white rounded-xl mb-6 ">
			<p className="text-xl mb-2 font-medium">
				Refer new customers. earn commissions. Unlock exclusive rewards. Earn Cash (and More) with ClickGuard
			</p>
			<p className="text-t-checkbox-unactive text-base">
				Already love ClickGuard? Share it with others and get rewarded! With your unique referral link, you can turn
				recommendations into real earnings.
			</p>
			<div className="flex flex-col justify-center gap-y-4 pt-6 pb-8">
				<div>
					<p className="text-base font-medium">Up to 35% Lifetime Commission</p>
					<div className="flex items-baseline gap-x-4 pt-1">
						<p className="text-t-checkbox-unactive text-base">
							Every customer you bring in earns you a up to 35% commission on all sales—for 2 years. As long as they're
							a ClickGuard customer, you keep earning.
						</p>
					</div>
				</div>
				<div>
					<p className="text-base font-medium">60-Day Cookie Tracking</p>
					<div className="flex items-baseline gap-x-4 pt-1">
						<p className="text-t-checkbox-unactive text-base">
							With a 60-day cookie lifespan, you'll still earn commissions even if your referral signs up weeks after
							clicking your link.
						</p>
					</div>
				</div>
				<div>
					<p className="text-base font-medium">Reliable Monthly Payouts</p>
					<div className="flex items-baseline gap-x-4 pt-1">
						<p className="text-t-checkbox-unactive text-base">
							No long waits or complicated processes. You'll get paid every month, right on time, for the commissions
							you've earned.
						</p>
					</div>
				</div>
				<p className="text-t-checkbox-unactive text-base">
					By joining the ClickGuard Affiliate Program, you agree to our{' '}
					<a href={`${EXTERNAL_APP_BASE_URL}/terms-of-service`} target="_blank" className="text-t-email-blue ">
						Terms and Conditions
					</a>
					.
				</p>
			</div>
			<div className="flex justify-start items-center gap-x-4">
				<GButton
					icon={MdCheck}
					label="Become an Affiliate"
					color="yellow"
					labelClassName="font-medium text-base"
					className="rounded-full disabled:!shadow-none !shadow-s-yellow"
					onClick={() => window.open(AFFILIATE_SIGNUP_URL, '_blank')}
				/>
				<GButton
					icon={RiShareBoxFill}
					iconPlacement="right"
					iconClassName="!w-3.5 !h-3.5"
					size="lg"
					label="Login to Affiliate Portal"
					color={'buttonPrimary'}
					variant={'text'}
					labelClassName="font-medium"
					className="h-[40px] px-4 shadow-none border hover:bg-t-base-blue hover:text-white transition-all duration-200 text-color-text-default outline-0 !border-t-google-btn rounded-full"
					onClick={() => window.open(AFFILIATE_LOGIN_URL, '_blank')}
				/>
			</div>
		</div>
	)
}
